import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Mail, CheckCircle2, AlertTriangle } from "lucide-react";
import { API_URL } from "../../lib/utils";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

export const POSEmailInvoice = ({ invoice }) => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { setEmail(invoice?.customer_email || ""); setSent(null); setError(""); }, [invoice?.invoice_id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!invoice?.invoice_id) return null;
  const trimmed = email.trim();
  const valid = EMAIL_RE.test(trimmed);

  const send = async () => {
    if (!valid) { setError("Introduza um email válido do cliente (ex.: nome@empresa.ao)"); return; }
    setBusy(true);
    setError("");
    try {
      const r = await axios.post(`${API_URL}/invoices/${invoice.invoice_id}/email`, { to: trimmed }, { withCredentials: true });
      setSent(r.data.to);
      toast.success(r.data.message);
    } catch (e) {
      const msg = e.response?.status === 401 ? "Sessão expirada — volte a entrar" : e.response?.data?.detail || (e.response ? `Erro ${e.response.status} ao enviar a factura` : "Sem ligação ao servidor");
      setError(typeof msg === "string" ? msg : "Erro ao enviar a factura");
      toast.error(typeof msg === "string" ? msg : "Erro ao enviar a factura");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid="pos-email-block">
      <p className="text-xs font-semibold uppercase text-muted-foreground flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> Enviar factura por email?</p>
      {sent ? (
        <p className="text-sm text-emerald-600 flex items-center gap-1" data-testid="pos-email-sent"><CheckCircle2 className="w-4 h-4" /> Enviada para {sent}</p>
      ) : (
        <>
          <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (!busy) send(); }}>
            <Input type="email" inputMode="email" autoComplete="off" placeholder="email do cliente" value={email} onChange={(e) => { setEmail(e.target.value); setError(""); }} className="h-9" aria-invalid={!!error} data-testid="pos-email-input" />
            <Button type="submit" size="sm" className="h-9" disabled={busy} data-testid="pos-email-send-btn">{busy ? "A enviar…" : "Enviar"}</Button>
          </form>
          {error ? (
            <p className="text-xs text-red-500 flex items-start gap-1" data-testid="pos-email-error"><AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {error}</p>
          ) : (
            <p className="text-[11px] text-muted-foreground" data-testid="pos-email-hint">
              {invoice.customer_email ? "Email da ficha do cliente — pode alterar antes de enviar." : "Sem email na ficha do cliente — escreva o email para enviar o PDF da factura."}
            </p>
          )}
        </>
      )}
    </div>
  );
};
